import { get, post } from '$fetch'

/**
 * 车辆收藏确认
 * @param {String} token token
 * @param {String} carid 车源id
 */
export const favoriteConfirm = params => get('/lurker/v1/favorite/confirm', params, {
  isLoading: true
})

/**
 * 车辆收藏
 * @param {String} token token
 * @param {String} carid 车源id
 */
export const favoriteAdd = params => post('/lurker/v1/favorite/add', params, {
  isLoading: true
})

/**
 * 车辆取消收藏
 * @param {String} token token
 * @param {String} carid 车源id
 */
export const favoriteRemove = params => get('/lurker/v1/favorite/remove', params, {
  isLoading: true
})
